import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from '../../../../utils/newLoader';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const screenCode = 'BLDETAILEDCALCULATIONSREPORT';

export default function DailyCropReport(props) {
  const [title, setTitle] = useState("BL Detailed Calculations Report");
  const classes = useStyles();
  const [dailyCropDetail, setDailyCropDetail] = useState({
    groupID: 0,
    factoryID: 0,
    date: moment(new Date()).format('YYYY-MM')
  });
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [dailyCropData, setDailyCropData] = useState([]);
  const [totals, setTotals] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
  })
  const navigate = useNavigate();
  const alert = useAlert();
  const [csvHeaders, SetCsvHeaders] = useState([])
  const componentRef = useRef();

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [dailyCropDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [dailyCropDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLDETAILEDCALCULATIONSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setDailyCropDetail({
      ...dailyCropDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(dailyCropDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(dailyCropDetail.factoryID);
    setRoutes(routeList);
  }

  async function GetDetails() {
    const cropData = await services.GetBalancePaymentDetails(dailyCropDetail.groupID, dailyCropDetail.factoryID, dailyCropDetail.date);
    getSelectedDropdownValuesForReport(dailyCropDetail.groupID, dailyCropDetail.factoryID, dailyCropDetail.routeID);
    if (cropData.statusCode == "Success" && cropData.data != null) {
      cropData.data.forEach(x => {
        x.leafTotal = x.normalLeaf + x.superLeaf
        x.normalGross = x.normalLeaf * x.normalLeafRate
        x.superGross = x.superLeaf * x.superLeafRate
        x.amountDue = (x.normalLeaf * x.normalLeafRate) + (x.superLeaf * x.superLeafRate)
        x.trasport = (x.normalLeaf + x.superLeaf) * x.transportRate
        x.totalDeduction = (x.deductions[0].tea) + (x.deductions[0].advance) + (x.deductions[0].loan) + (x.deductions[0].otherDeductions) + (x.deductions[0].stamp) + (x.deductions[0].cashBalanceBF) + ((x.normalLeaf + x.superLeaf) * x.transportRate)
        x.amountToPay = ((x.amountDue >= x.totalDeduction) ? Math.abs(x.amountDue - x.totalDeduction) : 0)
        x.debitToFactory = ((x.amountDue <= x.totalDeduction) ? Math.abs(x.amountDue - x.totalDeduction) : 0)
        x.coinsCF = ((x.amountDue >= x.totalDeduction) ? (x.amountToPay % 10).toFixed(2) : 0)
        x.balance = ((x.amountDue >= x.totalDeduction) ? (x.amountToPay - x.coinsCF).toFixed(2) : 0)
        x.totalToDeduct = (x.deductions[0].lastMonthBalance) + (x.deductions[0].thisMonthInstallment)
      });
      setDailyCropData(cropData.data);

      let totalModel = [];
      let totalNLQty = 0; let totalNLGross = 0; let totalSLQty = 0; let totalSLGross = 0; let totalLeaf = 0; let totalAmountDue = 0; let totalBFCoins = 0; let totalLMB = 0;
      let totalTMTI = 0; let totalTMI = 0; let totalTTD = 0; let totalTea = 0; let totalCBBF = 0; let totalAdvance = 0; let totalTransport = 0; let totalStamp = 0; let totalLoan = 0;
      let totalOtherDeduction = 0; let totalDeduction = 0; let totalATP = 0; let totalTDTF = 0; let totalCFCoins = 0; let totalBalance = 0;
      cropData.data.forEach(x => {
        totalNLQty += x.normalLeaf; totalModel.totalNLQty = totalNLQty.toFixed(2);
        totalNLGross += x.normalGross; totalModel.totalNLGross = totalNLGross.toFixed(2);
        totalSLQty += x.superLeaf; totalModel.totalSLQty = totalSLQty.toFixed(2);
        totalSLGross += x.superGross; totalModel.totalSLGross = totalSLGross.toFixed(2);
        totalLeaf += x.leafTotal; totalModel.totalLeaf = totalLeaf.toFixed(2);
        totalAmountDue += x.amountDue; totalModel.totalAmountDue = totalAmountDue.toFixed(2);
        totalBFCoins += x.deductions[0].coinsBF; totalModel.totalBFCoins = totalBFCoins.toFixed(2);
        totalLMB += x.deductions[0].lastMonthBalance; totalModel.totalLMB = totalLMB.toFixed(2);
        totalTMTI += x.deductions[0].lastMonthTotalIssued; totalModel.totalTMTI = totalTMTI.toFixed(2);
        totalTMI += x.deductions[0].thisMonthInstallment; totalModel.totalTMI = totalTMI.toFixed(2);
        totalTTD += x.totalToDeduct; totalModel.totalTTD = totalTTD.toFixed(2);
        totalTea += x.deductions[0].tea; totalModel.totalTea = totalTea.toFixed(2);
        totalCBBF += x.deductions[0].cashBalanceBF; totalModel.totalCBBF = totalCBBF.toFixed(2);
        totalAdvance += x.deductions[0].advance; totalModel.totalAdvance = totalAdvance.toFixed(2);
        totalTransport += x.transportRate; totalModel.totalTransport = totalTransport.toFixed(2);
        totalStamp += x.deductions[0].stamp; totalModel.totalStamp = totalStamp.toFixed(2);
        totalLoan += x.deductions[0].loan; totalModel.totalLoan = totalLoan.toFixed(2);
        totalOtherDeduction += x.deductions[0].otherDeductions; totalModel.totalOtherDeduction = totalOtherDeduction.toFixed(2);
        totalDeduction += x.totalDeduction; totalModel.totalDeduction = totalDeduction.toFixed(2);
        totalATP += x.amountToPay; totalModel.totalATP = totalATP.toFixed(2);
        totalTDTF += x.debitToFactory; totalModel.totalTDTF = totalTDTF.toFixed(2);
        totalCFCoins += ((x.coinsCF * 10) / 10); totalModel.totalCFCoins = parseFloat(totalCFCoins);
        totalBalance += Math.trunc(x.balance); totalModel.totalBalance = totalBalance;
      })
      setTotals(totalModel)
    }
    else {
      alert.error("No records to display");
    }
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Reg No': x.registrationNumber,
          'Name': x.name,
          'NL QTY': x.normalLeaf.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'NL Rate': x.normalLeafRate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'NL Gross': x.superLeaf.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'SL QTY': x.normalGross.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'SL Rate': x.superLeafRate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'SL Gross': x.superGross.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'LEAF TOTAL': x.leafTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'AMOUNT DUE': x.amountDue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'COINS B/F': x.deductions[0].coinsBF.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'LAST MONTH BALANCE': x.deductions[0].lastMonthBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'THIS MONTH TOTAL ISSUED': x.deductions[0].lastMonthTotalIssued.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'THIS MONTH INSTALLMENT': x.deductions[0].thisMonthInstallment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'TOTAL TO DEDUCT': x.totalToDeduct.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'TEA': x.deductions[0].tea.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'CASH BALANCE B/F': x.deductions[0].cashBalanceBF.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'ADVANCE': x.deductions[0].advance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'TRANSPORT': x.trasport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'STAMP': x.deductions[0].stamp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'LOAN': x.deductions[0].loan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'OTHER DEDUCT.': x.deductions[0].otherDeductions.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'TOTAL DEDUCT.': x.totalDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'AMOUNT TO PAY': x.amountToPay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'TOTAL DEBIT TO FACTORY': x.debitToFactory.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'COINS C/F': x.coinsCF.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'BALANCE ': x.balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'PAY. MODE': x.payMode,
        }
        res.push(vr);
      });
      var vr = {
        'NL QTY': totals.totalNLQty.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'NL Rate': "",
        'NL Gross': totals.totalNLGross.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'SL QTY': totals.totalSLQty.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'SL Rate': "",
        'SL Gross': totals.totalSLGross.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'LEAF TOTAL': totals.totalLeaf.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'AMOUNT DUE': totals.totalAmountDue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'COINS B/F': totals.totalBFCoins.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'LAST MONTH BALANCE': totals.totalLMB.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'THIS MONTH TOTAL ISSUED': totals.totalTMTI.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'THIS MONTH INSTALLMENT': totals.totalTMI.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'TOTAL TO DEDUCT': totals.totalTTD.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'TEA': totals.totalTea.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'CASH BALANCE B/F': totals.totalCBBF.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'ADVANCE': totals.totalAdvance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'TRANSPORT': totals.totalTransport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'STAMP': totals.totalStamp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'LOAN': totals.totalLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'OTHER DEDUCT.': totals.totalOtherDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'TOTAL DEDUCT.': totals.totalDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'AMOUNT TO PAY': totals.totalATP.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'TOTAL DEBIT TO FACTORY': totals.totalTDTF.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'COINS C/F': totals.totalCFCoins.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'BALANCE ': totals.totalBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      }
      res.push(vr);

      res.push({});

      var vr = {
        'Reg No': 'Factory : ' + selectedSearchValues.factoryName
      }
      res.push(vr);

      var vr = {
        'Reg No': 'Date : ' + moment(dailyCropDetail.date).format('MMMM - YYYY')
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(dailyCropData);
    var settings = {
      sheetName: 'BL Detailed Calculations Report',
      fileName: 'BL Detailed Calculations Report - ' + selectedSearchValues.factoryName + ' ' + dailyCropDetail.date,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'BL Detailed Calculations Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      routeName: routes[routeID]
    })
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setDailyCropDetail({
      ...dailyCropDetail,
      [e.target.name]: value
    });
    setDailyCropData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: dailyCropDetail.groupID,
              factoryID: dailyCropDetail.factoryID,
              date: dailyCropDetail.date
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                date: Yup.string().required('Select a date'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          {/* <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid> */}
                          {/* <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              size='small'
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid> */}
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="date">
                              Month *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.date && errors.date)}
                              fullWidth
                              helperText={touched.date && errors.date}
                              size='small'
                              name="date"
                              type="month"
                              onChange={(e) => handleChange(e)}
                              value={dailyCropDetail.date}
                              variant="outlined"
                              id="date"
                            />
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                onClick={() => GetDetails()}
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                        <br>
                        </br>
                        <br>
                        </br>
                        <Box minWidth={950} hidden={dailyCropData.length == 0}>
                          <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
                            <Table size="small" aria-label="sticky table" Table stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell colSpan={9} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }}></TableCell>
                                  <TableCell colSpan={2} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }} align="center">EARNINGS</TableCell>
                                  <TableCell colSpan={4} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }} align="center">FERTILIZER</TableCell>
                                  <TableCell colSpan={7} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }} align="center">CASH ADVANCE & OTHER RECOVERIES</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }}></TableCell>
                                  <TableCell colSpan={2} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }} align="center">FINAL BALANCE</TableCell>
                                  <TableCell colSpan={3} style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px" }}></TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>REG.NO.</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>NAME</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>NL QTY (kg)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>NL RATE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>NL GROSS (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>SL QTY (kg)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>SL RATE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>SL GROSS (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>LEAF TOTAL (kg)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>AMOUNT DUE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>COINS B/F (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>LAST MONTH BALANCE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>THIS MONTH TOTAL ISSUED (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>THIS MONTH INSTALLMENT (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>TOTAL TO DEDUCT (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>TEA (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>CASH BALANCE B/F (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>ADVANCE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>TRANSPORT RT (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>STAMP (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>LOAN (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>OTHER DEDUCT. (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>TOTAL DEDUCT. (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>AMOUNT TO PAY (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>TOTAL DEBIT TO FACTORY (Rs.)</TableCell>

                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>COINS C/F (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>BALANCE (Rs.)</TableCell>
                                  <TableCell style={{ top: 37, border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}>PAY. MODE</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {dailyCropData.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{row.registrationNumber}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{row.name}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.normalLeaf).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.normalLeafRate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.normalGross).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.superLeaf).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.superLeafRate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.superGross).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.leafTotal).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.amountDue).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].coinsBF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].lastMonthBalance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].lastMonthTotalIssued).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].thisMonthInstallment).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.totalToDeduct).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].tea).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].cashBalanceBF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].advance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.trasport).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].stamp).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].loan).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.deductions[0].otherDeductions).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.totalDeduction).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.amountToPay).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.debitToFactory).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.coinsCF).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{(parseFloat(row.balance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: "1px solid black", fontSize: "11px", padding: '2px' }}>{row.payMode}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableRow>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalNLQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalNLGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalSLQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalSLGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalLeaf).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalAmountDue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalBFCoins).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalLMB).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTMTI).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTMI).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTTD).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTea).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalCBBF).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalAdvance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTransport).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalStamp).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalLoan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalOtherDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalATP).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalTDTF).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalCFCoins).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> {parseFloat(totals.totalBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "12px", padding: '2px' }}> </TableCell>
                              </TableRow>
                            </Table>
                          </TableContainer>
                        </Box>
                      </CardContent>
                      <Divider />
                      {dailyCropData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"BL Detailed Calculations Report"}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              dailyCropData={dailyCropData}
                              searchData={selectedSearchValues}
                              totals={totals}
                              dailyCropDetail={dailyCropDetail}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}
